import { render, staticRenderFns } from "./StadiumBoostUpdateCustomerForm.vue?vue&type=template&id=02765f52&"
import script from "./StadiumBoostUpdateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostUpdateCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports